import { getNegotiateCopyText, isChatSubmitKey, mapNegotiateMessage, MessageNegotiate } from 'src/app/core/services/negotiation-chat';
export { MessageNegotiate, MergeFieldHistory } from 'src/app/core/services/negotiation-chat';
import { ActivatedRoute, Router } from '@angular/router';
import { AutoUserService } from 'src/app/core/services/auto-user.service';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  TemplateRef,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { CommonService } from 'src/app/core/services/common.service';
import { CustomerService } from 'src/app/core/services/customer.service';
import { MatDialog } from '@angular/material';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ViewDocumentReferenceComponent } from 'src/app/shared/components/view-document-reference/view-document-reference.component';
import { DocumentService } from 'src/app/core/services/document.service';
import { ToastrService } from 'ngx-toastr';
import { Message } from 'src/app/core/class/message';
import { DocumentTypeService } from 'src/app/core/services/document-type.service';
import {
  EnumApproverStatus,
  EnumContractDetailType,
  EnumContractEnterpriseStatus,
  EnumContractStatus,
  EnumContractUserRole,
  EnumContractUserStatus,
  EnumSignMethod
} from 'src/app/core/constants/contract';
import { EnterpriseService } from 'src/app/core/services/enterprise.service';
import {BehaviorSubject, Subject} from 'rxjs';
import { NzConfigService } from 'ng-zorro-antd/core';
import { ContractService } from '../../../core/services/contract.service';
import { AnonymousSignService } from '../../../core/services/anonymous-sign.service';
import { ErrorCode } from 'src/app/core/constants/error-code';
import {EnumRoleUser} from "../../../core/constants/common";
import {DigitalContractService} from "../../../core/services/digital-contract.service";
import {ViewContractComponent} from "../../dashboard/home/home-enterprise/document/contract-digitization/view-contract/view-contract.component";
import {BlockUI, NgBlockUI} from "ng-block-ui";
import { finalize, take } from 'rxjs/operators';
import { ViewFilePdfImgComponent } from 'src/app/shared/components/view-file-pdf-img/view-file-pdf-img.component';

// -------------------------------BEGIN - Interface***-------------------------------//

interface EnterpriseElement {
  enterpriseId: number;
  order: number;
  email: string;
  enterpriseName: string;
  phoneNumber: number;
  status: boolean;
  isSameEntepriseCurrentLogin: boolean;
}

interface ViewUserElement {
  order: number;
  userId: string;
  enterpriseId: number;
  userName: string;
  userEmail: string;
  status: number;
  signingTime: Date;
  rejectionTime: Date;
}

// ant design
interface ParentItemData {
  key: number;
  name: string;
  platform: string;
  version: string;
  upgradeNum: number | string;
  creator: string;
  createdAt: string;
  expand: boolean;
}

interface ChildrenItemData {
  key: number;
  name: string;
  date: string;
  upgradeNum: string;
}

export interface TreeNodeInterface {
  key: number;
  order: string;
  name?: string;
  contact?: string;
  status?: string;
  role?: string;
  comment?: string;
  time?: string;
  certificateNo?: string;
  showNoFlowNotification: boolean;
  establishSignNoLogin?: boolean;
  isSignedAnonymous?: boolean;
  type: string;
  level?: number;
  expand?: boolean;
  children?: TreeNodeInterface[];
  parent?: TreeNodeInterface;
}

// -------------------------------END - Interface***-------------------------------//

@Component({
  selector: 'app-anonymous-detail-panel',
  templateUrl: './anonymous-detail-panel.component.html',
  styleUrls: ['./anonymous-detail-panel.component.scss']
})
export class AnonymousDetailPanelComponent implements OnInit, AfterViewInit, OnDestroy {

  // -------------------------------BEGIN - Available***-------------------------------//

  // DRAFT(0),
  // WAIT_1(1),
  // SINGED_1(2),
  // REJECT_1(3),
  // WAIT_2(4),
  // SINGED_2(5),
  // REJECT_2(6);
  // Finish (7); ?
  // 0 - Nháp
  // 1- Chờ ký bên lập
  // 2 - Đã ký bên lập
  // 3 - Từ chối bên lập
  // 4 - Chờ ký bên nhận
  // 5 - Ký bên nhận
  // 6 - Từ chối bên nhận
  // 7 - HOÀN THÀNH
  // 8 - Mới gởi qua bên nhận

  documentReference = [];
  documentParentName = '';
  document: any = {
    id: '',
    code: '',
    name: '',
    parentId: '',
    enterpriseId: localStorage.getItem('enterpriseId'),
    documentTypeEnterpriseId: '',
    customerId: '',
    status: 0,
    filePath: '',
    description: '',
    assignUserId: 0,
    submitedTo: 0,
    submitedToA: '',
    submitedTime: '',
    typeId: null,
    isDeleted: true,
    jsonData: '',
    email: '',
    phone: '',
    createdBy: '',
    createdTime: '',
    updatedBy: '',
    updatedTime: '',
    finishDate: '',
    salt: '',
    documentTypeContent: '',
    expiredDate: '',
    contractAttachments: [],
    newUploadContractAttachments: [],
    isSended: false,
    serviceType: '',
    processDate: '',
    bctConfirmStatus: null,
    isConfirmBCT: null,
    userNameAdmin:'',
    ceStatus: null
  };
  public isSignNow: any;
  public isSetUpSignFlow: boolean = false;
  pdfSrc = '';
  cecaEnable: boolean;
  roleUser = EnumContractUserRole;
  public isPanelDocumentViewSuccess = new Subject();
  permissionContractShare = localStorage.getItem('permissionContractShare') || null
  @Output() navigate: any = new EventEmitter<boolean>();
  @Input() documentInfo: any;
  @ViewChild('contentEmptyTable', { static: false }) contentEmptyTable: TemplateRef<any>; // Set no display No_data on Nz-Table
  userType: number;
  expanded = [];
  // enum
  enumContractStatus = EnumContractStatus;
  enumContractEnterpriseStatus = EnumContractEnterpriseStatus;
  enumContractUserRole = EnumContractUserRole;
  enumContractUserStatus = EnumContractUserStatus;
  enumContractDetailType = EnumContractDetailType;
  enumApproverStatus = EnumApproverStatus;
  enumSignMethod = EnumSignMethod;

  @BlockUI() blockUI: NgBlockUI;
  contractView = {
    contractName: '',
    id: [],
    filesName: [],
    listFileSize: [],
    idDocument:'',
    checkMan:2,
    isAnonymous: true,
    attachments: [],
    isTerminate: false,
  };

  documentId = '';
  isSetSignFlow = false;
  isTakenSideView = true;
  checkUSerCreateContract: boolean = false;
  enterpriseIdSignInFlow: string = '';
  mapOfExpandData: { [key: string]: boolean } = {};
  // -------------------------------***END - Available***-------------------------------//
  listOfMapData = [];
  mapOfExpandedData: { [key: string]: any } = {};
  public enterpriseId: string;
  public listEnterpriseSign = [];
  public listOfDataUserSign = [];
  @Output() hasChange: EventEmitter<boolean> = new EventEmitter();
  @Output() isSignNowParent: EventEmitter<boolean> = new EventEmitter();
  @Output() isSetUpSignFlowParent: EventEmitter<boolean> = new EventEmitter();
  private isFormChanging: boolean;
  public listInitial = [];
  @Input() documentData: any;
  private enterpriseSignIdInFlow: string;
  private userSign = [];
  public listDataApprover = []
  private hashKey: string;
  private tenantId: string;

  isNotAttestedUser: boolean = false;

  constructor(
    private commonService: CommonService,
    private customerService: CustomerService,
    private dialog: MatDialog,
    public notificationService: NotificationService,
    private documentService: DocumentService,
    private toastr: ToastrService,
    private message: Message,
    private documentTypeService: DocumentTypeService,
    public autoUserService: AutoUserService,
    private enterpriseService: EnterpriseService,
    private router: ActivatedRoute,
    private contractService: ContractService,
    private nzConfigService: NzConfigService,
    private anonymousSignService: AnonymousSignService,
    private route: ActivatedRoute,
    private routers: Router,
    private digitalContractService: DigitalContractService,
    private cdr: ChangeDetectorRef,
    private zone: NgZone
    ) {
    this.isNotAttestedUser = this.commonService.checkEnterpriseAnonymusType();
    this.userType = Number(localStorage.getItem('userType'));
    this.documentId = this.router.snapshot.paramMap.get('id');
    this.enterpriseId = localStorage.getItem('enterpriseId');
    this.cecaEnable = localStorage.getItem('cecaEnable') == 'true';
    localStorage.removeItem('AnonymousListEnterprise');
    this.route.paramMap.subscribe(params => {
      this.hashKey = params.get('hashKey');
      this.tenantId = params.get('tenantId');
      this.getListEnterprise();
      //An
    setTimeout(() => {
    // lấy document data từ bên view-detail truyền sang qua service
    this.anonymousSignService.documentInfo.subscribe((data) => {
      if (data) {
        this.document = {
          ...this.document,
          ...data
        };
        this.isNegotiate = !!data.negotiate
        if(this.permissionContractShare){
          this.isNegotiate = false
        }
        if(this.isNegotiate){
          this.documentService.getApparamInfo({code: 'negotiate_max_file'}).subscribe(res => {
            if(res.data.value){
              this.maxNumberFile = res.data.value
            }
          })
          this.documentService.getApparamInfo({code: 'negotiate_max_capacity'}).subscribe(res => {
            if(res.data.value){
              this.maxSize = res.data.value
            }
          })
          this.getHistoryChat(true)
          if(this.intervalChat){
            clearInterval(this.intervalChat)
          }
          this.intervalChat = setInterval(()=>{
            this.getHistoryChat()
          },10000)
        }
        if (this.hashKey && this.tenantId) {
          this.getListEnterprise();
        }
      }
    });
    }, 2000);
    });
  }

  collapse(array, data, $event: boolean): void {
    if ($event === false) {
      if (data.children) {
        data.children.forEach(d => {
          const target = array.find(a => a.key === d.key)!;
          target.expand = false;
          this.collapse(array, target, false);
        });
      } else {
        return;
      }
    }
  }

  convertTreeToList(root) {
    // console.log(root);
    const stack = [];
    const array = [];
    const hashMap = {};
    stack.push({ ...root, level: 0, expand: false });

    while (stack.length !== 0) {
      const node = stack.pop()!;
      this.visitNode(node, hashMap, array);
      if (node.children) {
        for (let i = node.children.length - 1; i >= 0; i--) {
          stack.push({ ...node.children[i], level: node.level! + 1, expand: false, parent: node });
        }
      }
    }
    return array;
  }

  visitNode(node: TreeNodeInterface, hashMap: { [key: string]: boolean }, array: TreeNodeInterface[]): void {
    if (!hashMap[node.key]) {
      hashMap[node.key] = true;
      array.push(node);
    }
  }

  /**
   * Init component
   */
  ngOnInit() {

  }

  ngAfterViewInit() {
    // Set empty when nz-table has NO-DATA
    this.nzConfigService.set('empty', { nzDefaultEmptyContent: this.contentEmptyTable });
  }

  ngOnDestroy(){
    if(this.intervalChat){
      clearInterval(this.intervalChat)
    }
  }

  /**
   * View document reference.
   * @param id The document id.
   */
  public viewDocumentReference(id) {
    if (id) {
      if(!id.referenceContractId){
        id.referenceContractId = id.id
      }
      this.dialog.open(ViewDocumentReferenceComponent, {
        width: '1000px',
        data: id,
      });
    } else {
      if (!this.toastr.findDuplicate(this.message.getMessage('messages.not_documentId'), true, true)) {
        this.toastr.error(this.message.getMessage('messages.not_documentId'));
      }
    }
  }

  getListEnterprise() {
    this.anonymousSignService.getListEnterprise(this.hashKey, this.tenantId).subscribe(rs => {
      console.log(33333,rs);
      if(rs.code == ErrorCode.HasApproval){
        this.routers.navigate(['/approval/success']);
        return
      }
      if(rs.code == ErrorCode.HasRejectApproval){
        this.routers.navigate(['/approval/reject']);
        return
      }
      if (rs.data) {
        this.enterpriseIdSignInFlow = rs.data.enterpriseSignIdInFlow;
        localStorage.setItem('AnonymousListEnterprise', JSON.stringify(rs.data));
        const {enterpriseSign, enterpriseSignIdInFlow, userSign, userApproves} = rs.data;
        this.getDocumentById(enterpriseSign, userSign, userApproves, null, enterpriseSignIdInFlow);
        this.anonymousSignService.setListEnterprise(enterpriseSign);
        this.anonymousSignService.setUserSign(userSign);
        // }
      }
    }, (error) => console.log(error));
  }

  public getDocumentById(enterpriseSign = [], userSign = [], userApproves = [], initial = [], enterpriseSignIdInFlow: string) {
    this.listEnterpriseSign = enterpriseSign;
    this.listOfDataUserSign = userSign.filter(item => item.enterpriseId === this.enterpriseId);
     this.isSetUpSignFlow = enterpriseSign.some(x => ( x.enterpriseId == enterpriseSignIdInFlow || x.customerId == enterpriseSignIdInFlow )&& x.isSetUpSignFlow == true)
    console.log(this.isSetUpSignFlow)
    // kiểm tra xem nó có được thêm luồng ký nội bộ hay không
    // map data for signing flow
    if (enterpriseSign) {
      const arr = [];
      let signMetadata: any;

      let arrayUserCreateContract = enterpriseSign.filter((data) => data.enterpriseId == JSON.parse(localStorage.getItem('AnonymousListEnterprise')).enterpriseSignIdInFlow && data.isCreatedSide == true);
      if(arrayUserCreateContract.length) {
        this.checkUSerCreateContract = true;
      } else {
        this.checkUSerCreateContract = false;
      }
      if(!this.isSetUpSignFlow){
        this.isSignNow = true;
        this.isSignNowParent.emit(this.isSignNow);
        this.isSetUpSignFlowParent.emit(this.isSetUpSignFlow);
        for (let index = 0; index < enterpriseSign.length; index++) {
          const childrenItems = [];
          // if (enterpriseSign[index].enterpriseId == enterpriseSignIdInFlow ||
          //   (enterpriseSignIdInFlow == null && enterpriseSign[index].customerId != undefined && enterpriseSign[index].enterpriseId == this.enterpriseId)) {
          //   if (enterpriseSign[index].isSignedAnonymous == false) {          // Nếu đơn vị chưa hoặc không thực hiện ký qua email, có đăng nhập tài khoản hệ thống
          //     if (userSign && userSign.length > 0) {
          //       for (let j = 0; j < userSign.length; j++) {
          //         childrenItems.push({
          //           key: (index + 1) * 10 + (j + 1),
          //           order: enterpriseSign[index].order + '.' + (userSign[j].order != undefined ? userSign[j].order : userSign.length),
          //           name: userSign[j].userName,
          //           status: userSign[j].status,
          //           showNoFlowNotification: false,
          //           role: userSign[j].role,
          //           type: this.enumContractDetailType.USER,
          //           children: [{
          //             key: ((index + 1) * 10 + (j + 1)) * 10 + 1,
          //             order: '',
          //             contact: userSign[j].userEmail + (userSign[j].userPhone ? (' - ' + userSign[j].userPhone) : ''),
          //             status: userSign[j].status,
          //             comment: (userSign[j].comment != null) ? userSign[j].comment : '',
          //             time: (userSign[j].processedAt != null) ? userSign[j].processedAt : '',
          //             showNoFlowNotification: false,
          //             role: userSign[j].role,
          //             type: this.enumContractDetailType.DETAIL
          //           }]
          //         });
          //       }
          //       this.isTakenSideView = !userSign[0].isCreatedSide;      // đã set luồng ký >> xác định Bên Lập hay Bên Nhận theo thông tin isCreatedSide của user
          //     } else {
          //       childrenItems.push({
          //         key: (index + 1) * 10 + 1,
          //         order: '',
          //         name: '',
          //         showNoFlowNotification: true,
          //         type: this.enumContractDetailType.DETAIL
          //       });
          //       this.isTakenSideView = true;       // chưa set luồng ký >> đó là Bên Nhận
          //     }
          //   } else {
          //     // Nếu đơn vị đã thực hiện ký qua email, không đăng nhập tài khoản hệ thống
          //     childrenItems.push({
          //       key: (index + 1) * 10 + 1,
          //       order: '',
          //       contact: enterpriseSign[index].enterpriseEmail + ' - ' + enterpriseSign[index].enterprisePhone,
          //       certificateNo: enterpriseSign[index].enterpriseCertificateNo,
          //       status: enterpriseSign[index].status,
          //       comment: (enterpriseSign[index].comment != null) ? enterpriseSign[index].comment : '',
          //       time: (enterpriseSign[index].processedAt != null) ? enterpriseSign[index].processedAt : '',
          //       showNoFlowNotification: false,
          //       establishSignNoLogin: true,
          //       isSignedAnonymous: true,
          //       type: this.enumContractDetailType.DETAIL
          //     });
          //   }
          // } else {
          //   childrenItems.push({
          //     key: (index + 1) * 10 + 1,
          //     order: '',
          //     contact: enterpriseSign[index].enterpriseEmail + ' - ' + enterpriseSign[index].enterprisePhone,
          //     certificateNo: enterpriseSign[index].enterpriseCertificateNo,
          //     status: enterpriseSign[index].status,
          //     comment: (enterpriseSign[index].comment != null) ? enterpriseSign[index].comment : '',
          //     time: (enterpriseSign[index].processedAt != null) ? enterpriseSign[index].processedAt : '',
          //     showNoFlowNotification: false,
          //     establishSignNoLogin: (enterpriseSign[index].isSignNoLogin != null) ? enterpriseSign[index].isSignNoLogin : false,
          //     isSignedAnonymous: (enterpriseSign[index].isSignedAnonymous != null) ? enterpriseSign[index].isSignedAnonymous : false,
          //     type: this.enumContractDetailType.DETAIL
          //   });
          // }
          if(enterpriseSign[index].signMetadata){
            signMetadata = JSON.parse(enterpriseSign[index].signMetadata);
          }
          childrenItems.push({
            key: (index + 1) * 10 + 1,
            order: '',
            contact: (enterpriseSign[index].enterpriseEmail ? enterpriseSign[index].enterpriseEmail + ' - ' : '') + enterpriseSign[index].enterprisePhone,
            certificateNo: enterpriseSign[index].enterpriseCertificateNo,
            status: enterpriseSign[index].status,
            comment: (enterpriseSign[index].comment != null) ? enterpriseSign[index].comment : '',
            time: (enterpriseSign[index].processedAt != null) ? enterpriseSign[index].processedAt : '',
            showNoFlowNotification: false,
            establishSignNoLogin: (enterpriseSign[index].isSignNoLogin != null) ? enterpriseSign[index].isSignNoLogin : false,
            isSignedAnonymous: (enterpriseSign[index].isSignedAnonymous != null) ? enterpriseSign[index].isSignedAnonymous : false,
            type: this.enumContractDetailType.DETAIL,
            signMethod: enterpriseSign[index].signMethod,
            signMetadata: signMetadata,
            identityStatus: enterpriseSign[index].identityStatus ? enterpriseSign[index].identityStatus : null,
            enterpriseId: enterpriseSign[index].enterpriseId,
            identityReason: enterpriseSign[index].identityReason ? enterpriseSign[index].identityReason : null,
          });
          const mainItem = {
            key: index + 1,
            order: enterpriseSign[index].order,
            name: enterpriseSign[index].enterpriseName,
            status: enterpriseSign[index].status,
            showNoFlowNotification: childrenItems[0].showNoFlowNotification,
            type: this.enumContractDetailType.ENTERPRISE,
            children: childrenItems,
            identityStatus: enterpriseSign[index].identityStatus ? enterpriseSign[index].identityStatus : null,
            enterpriseId: enterpriseSign[index].enterpriseId,
            identityReason: enterpriseSign[index].identityReason ? enterpriseSign[index].identityReason : null,
          };
          arr.push(mainItem);
        }
        this.mapOfExpandedData = {};
        arr.forEach(item => {
          this.mapOfExpandedData[item.key] = this.convertTreeToList(item);
        });
        console.log(this.mapOfExpandedData);
        this.listOfMapData = arr;
        console.log(this.listOfMapData);
      } else {
        // const userSignAll = [...userApproves,...this.listOfDataUserSign]
        userApproves.forEach(x => {x.role = 7 })
          if(userSign.length > 0 && userSign[0].status == 2) {
            this.isSignNow = true
          } else {
            this.isSignNow = false
          }
        this.isSignNowParent.emit(this.isSignNow);
        this.isSetUpSignFlowParent.emit(this.isSetUpSignFlow);
        console.log(this.isSignNow)
        userSign.forEach( x => userApproves.push(x))
        console.log(userApproves)
        for (let index = 0; index < enterpriseSign.length; index++) {
          let childrenItems = [];
          if (enterpriseSign[index] && enterpriseSign[index].signMetadata) {
            signMetadata = JSON.parse(enterpriseSign[index].signMetadata);
          }
          if (enterpriseSign[index].enterpriseId == enterpriseSignIdInFlow || enterpriseSign[index].customerId == enterpriseSignIdInFlow ||
            (enterpriseSignIdInFlow == null && enterpriseSign[index].customerId != undefined && enterpriseSign[index].enterpriseId == this.enterpriseId)) {
            if (enterpriseSign[index].isSignedAnonymous == false || (enterpriseSign[index].isSignedAnonymous && enterpriseSign[index].isSetUpSignFlow)){          // Nếu đơn vị chưa hoặc không thực hiện ký qua email, có đăng nhập tài khoản hệ thống
              if (userApproves && userApproves.length > 0) {
                childrenItems = this.mapDataUsign(userApproves,enterpriseSign[index],index,signMetadata);
                this.isTakenSideView = !userApproves[0].isCreatedSide; // đã set luồng ký >> xác định Bên Lập hay Bên Nhận theo thông tin isCreatedSide của user
              } else {
                childrenItems.push({
                  key: (index + 1) * 10 + 1,
                  order: '',
                  name: '',
                  showNoFlowNotification: true,
                  type: this.enumContractDetailType.DETAIL
                });
                this.isTakenSideView = true;       // chưa set luồng ký >> đó là Bên Nhận
              }
            } else {
              // Nếu đơn vị đã thực hiện ký qua email, không đăng nhập tài khoản hệ thống
              childrenItems = this.mapDataNoLogin(signMetadata,enterpriseSign[index],index);
              // childrenItems.push(children)
              console.log('2')
              this.isTakenSideView = true;       // đã ký qua link gửi về email >> đó là Bên Nhận
            }
          } else {
            childrenItems = this.mapDataNoSign(signMetadata,enterpriseSign[index],index);
            console.log('3')
          }
          const mainItem = {
            key: index + 1,
            order: enterpriseSign[index].order,
            name: enterpriseSign[index].enterpriseName,
            status: enterpriseSign[index].status,
            showNoFlowNotification: childrenItems[0].showNoFlowNotification,
            type: this.enumContractDetailType.ENTERPRISE,
            children: childrenItems,
            identityStatus: enterpriseSign[index].identityStatus ? enterpriseSign[index].identityStatus : null,
            enterpriseId: enterpriseSign[index].enterpriseId,
            identityReason: enterpriseSign[index].identityReason ? enterpriseSign[index].identityReason : null,
            // signConfig: enterpriseSign[index].signConfig ? (JSON.parse(enterpriseSign[index].signConfig).showImage ? JSON.parse(enterpriseSign[index].signConfig) : {showImage: false}) : {showImage: false}
          };
          arr.push(mainItem);
        }
        this.mapOfExpandedData = {};
        arr.forEach(item => {
          this.mapOfExpandedData[item.key] = this.convertTreeToList(item);
        });
        // console.log("mapOfExpandedData", this.mapOfExpandedData);


        this.listOfMapData = arr;
        console.log(this.listOfMapData)
      }

      // Check whether this enterprise create the document ?

    }
    if(userApproves){
      userApproves.forEach(item => {
        if (item.signConfig) {
          item.signConfig = JSON.parse(item.signConfig);
          item.signMetadata ? item.signMetadata = JSON.parse(item.signMetadata) : '';
        }
        if (item.signMetadata) {
          item.signMetadata = JSON.parse(item.signMetadata);
        }
      });
      this.listDataApprover = userApproves;
    }
  }

  /**
   * Get reference document.
   * @param referenceData the reference data.
   */
  public getDocumentRefer(referenceData) {
    this.documentReference = referenceData;
  }

  /**
   * Get servicetype by id
   */
  getServiceType(serviceTypeId) {
    this.commonService.getServiceType(serviceTypeId).subscribe(rs => {
      this.document.serviceType = rs.data.name;
    });
  }

  /**
   * Get inform service type of document type id
   * @param idDocumentType Document type id
   */
  getServiceTypeByDocumentTypeId(idDocumentType: string) {
    // this.documentTypeService.getServiceTypeByDocumentTypeId(idDocumentType).subscribe(rs => {
    //   if (rs.data) {
    //     this.document.serviceType = rs.data.name;
    //   }
    // });
  }

  downloadFile(id, name) {
    this.anonymousSignService.downloadDocumentFile(id, this.hashKey, this.tenantId).subscribe(rs => {
      this.downLoadFile(rs, 'application/octet-stream', name);
    });
  }

  /**
   * Method is use to download file.
   * @param data - Array Buffer data
   * @param type - type of the document.
   * @param fileName - file name of file
   */
  downLoadFile(data: any, type: string, fileName: string) {
    const blob = new Blob([data], { type });
    if (window.top.navigator.msSaveOrOpenBlob) {
      // Store Blob in IE
      window.top.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      // Store Blob in others
      const tA = document.body.appendChild(document.createElement('a'));
      tA.href = URL.createObjectURL(blob);
      tA.download = fileName;
      tA.style.display = 'none';
      tA.click();
      tA.parentNode.removeChild(tA);
    }
  }

  /**
   * Lấy danh sách Người dùng sẽ ký/Duyệt Hợp đồng && Lấy danh sách các bên chủ thể sẽ Ký Hợp đồng
   */
  getListEnterpriseUserSignByDocumentId1() {
    if (this.documentId) {
      this.documentService.getListEnterpriseUserSignBydocumentIdService(this.documentId).subscribe(rs => {
        if (rs.data) {
          let { enterpriseSign, userSign, initial } = rs.data;
          if (enterpriseSign && userSign) {
            userSign = userSign.map((item, index) => ({
              ...item,
              name: item.userName,
              isChild: true
              // key: index + 1
            }));
            enterpriseSign = enterpriseSign.map((item, index) => {
              let children = [];
              if (item.enterpriseId == this.enterpriseId) {
                children = userSign.filter(el => {
                  return el.enterpriseId == item.enterpriseId;
                });
                children = children.map((el, id) => {
                  return {
                    ...el,
                    key: Number(`${String(index + 1)}${id + 1}`),
                    order: `${String(index + 1)}.${id + 1}`,
                  };
                });
              } else {
                children = [{
                  ...item,
                  order: `${index + 1}.1`,
                  key: Number(`${String(index + 1)}${1}`),
                }];
              }

              const returnItem = {
                order: String(index + 1),
                key: index + 1,
                ...item,
                name: item.enterpriseName,
                isChild: false,
                isCurrentEnterprise: item.enterpriseId == this.enterpriseId,
                children
              };
              return returnItem;
            }
            );
            this.mapOfExpandedData = {};
            enterpriseSign.forEach(item => {
              this.mapOfExpandedData[item.key] = this.convertTreeToList(item);
            });
            // console.log('this.mapOfExpandedData', this.mapOfExpandedData);
            this.listOfMapData = enterpriseSign.sort();
            // console.log('this.listOfMapData', this.listOfMapData);
          }
        }
      }, (error) => console.log(error));
    }
  }

  setFormChanging(changingStatus: boolean): void {
    this.isFormChanging = changingStatus;
    this.hasChange.emit(changingStatus);
  }

  getMessageNoteSignFlowDesign() {
    return this.message.getMessage('note_sign_flow_design').replace('{0}', this.document.userNameAdmin);
  }
  mapDataUsign(userSign: any,enterpriseSignItem:any,index:any,signMetadataSignCustemor?:any){
    let childrenItems = [];
    let signMetadata: any;
    for (let j = 0; j < userSign.length; j++) {
      if (userSign[j].signMetadata) {
        signMetadata = JSON.parse(userSign[j].signMetadata);
      }
      childrenItems.push({
        key: (index + 1) * 10 + (j + 1),
        order: enterpriseSignItem.order + '.' + (userSign[j].order != undefined ? userSign[j].order : userSign.length),
        name: userSign[j].userName ? userSign[j].userName : (userSign[j].fullName ? userSign[j].fullName : enterpriseSignItem.enterpriseName),
        status: userSign[j].status,
        showNoFlowNotification: false,
        role: userSign[j].role,
        isSignDigitalCertificate: userSign[j].isSignDigitalCertificate,
        signConfig: userSign[j].signConfig ? this.setDataSignConfig(JSON.parse(userSign[j].signConfig)) : {
          resize: false,
          showImage: userSign[j].isSignDigitalCertificate ? false : (userSign[j].role + '' == EnumRoleUser.USER_SIGN ? true : false)
        },
        type: this.enumContractDetailType.USER,
        departmentName: userSign[j].departmentName,
        children: [{
          key: ((index + 1) * 10 + (j + 1)) * 10 + 1,
          order: '',
          contact:  (userSign[j].userEmail ? (userSign[j].userEmail + ' - ') : (userSign[j].email + ' - ')) + (userSign[j].userPhone ? userSign[j].userPhone : (userSign[j].phoneNumber ? (userSign[j].phoneNumber): '')),
          status: userSign[j].status,
          comment: (userSign[j].comment != null) ? userSign[j].comment : '',
          time: (userSign[j].processedAt != null) ? userSign[j].processedAt : '',
          showNoFlowNotification: false,
          role: userSign[j].role,
          isSignDigitalCertificate: userSign[j].isSignDigitalCertificate,
          signConfig: userSign[j].signConfig ? this.setDataSignConfig(JSON.parse(userSign[j].signConfig)) : {
            resize: false,
            showImage: userSign[j].isSignDigitalCertificate ? false : (userSign[j].role + '' == EnumRoleUser.USER_SIGN ? true : false)
          },
          type: this.enumContractDetailType.DETAIL,
          signMethod: (userSign[j].role == 1 && userSign[j].status == 4 ) ? enterpriseSignItem.signMethod : userSign[j].signMethod,
          signMetadata: ((userSign[j].role != 7 || userSign[j].role == 1)  && userSign[j].status == 4 ) ?  JSON.parse(enterpriseSignItem.signMetadata) : signMetadata,
          identityStatus: enterpriseSignItem.identityStatus ? enterpriseSignItem.identityStatus : null,
          enterpriseId: enterpriseSignItem.enterpriseId,
          identityReason: enterpriseSignItem.identityReason ? enterpriseSignItem.identityReason : null,
          signConfigEnterprise: {showImage: false},
          taxCode:userSign[j].taxCode,
          enterpriseType:enterpriseSignItem.enterpriseType,
          reasonUserApprove:enterpriseSignItem.identityReason ? null : (userSign[j].reason?userSign[j].reason : null),
          reasonApprove:enterpriseSignItem.identityReason ? null : (userSign[j].reasonApprove?userSign[j].reasonApprove : null),
          reasonSignUser:userSign[j].role == 1?enterpriseSignItem.comment:'',
        }]
      });
    }
    return childrenItems;
  }
  mapDataNoLogin(signMetadata,enterpriseSignItem,index){
    let childrenItems = [];
    childrenItems.push({
      key: (index + 1) * 10 + 1,
      order: '',
      contact: (enterpriseSignItem.enterpriseEmail ? enterpriseSignItem.enterpriseEmail + ' - ' : '')+ enterpriseSignItem.enterprisePhone,
      certificateNo: enterpriseSignItem.enterpriseCertificateNo,
      status: enterpriseSignItem.status,
      comment: (enterpriseSignItem.comment != null) ? enterpriseSignItem.comment : '',
      time: (enterpriseSignItem.processedAt != null) ? enterpriseSignItem.processedAt : '',
      showNoFlowNotification: false,
      establishSignNoLogin: true,
      isSignedAnonymous: true,
      type: this.enumContractDetailType.DETAIL,
      signMethod: enterpriseSignItem.signMethod,
      signMetadata: signMetadata,
      identityStatus: enterpriseSignItem.identityStatus ? enterpriseSignItem.identityStatus : null,
      enterpriseId: enterpriseSignItem.enterpriseId,
      identityReason: enterpriseSignItem.identityReason ? enterpriseSignItem.identityReason : null,
      isCreatedSide: enterpriseSignItem.isCreatedSide,
      enterpriseType:enterpriseSignItem.enterpriseType,
      signConfigEnterprise: enterpriseSignItem.signConfig ? (JSON.parse(enterpriseSignItem.signConfig).showImage ? JSON.parse(enterpriseSignItem.signConfig) : {showImage: false}) : {showImage: false}
    });
    return childrenItems
  }
  mapDataNoSign(signMetadata,enterpriseSignItem,index){
    let childrenItems = [];
    childrenItems.push({
      key: (index + 1) * 10 + 1,
      order: '',
      contact: (enterpriseSignItem.enterpriseEmail ? enterpriseSignItem.enterpriseEmail + ' - ' : '')+ enterpriseSignItem.enterprisePhone,
      certificateNo: enterpriseSignItem.enterpriseCertificateNo,
      status: enterpriseSignItem.status,
      comment: (enterpriseSignItem.comment != null) ? enterpriseSignItem.comment : '',
      time: (enterpriseSignItem.processedAt != null) ? enterpriseSignItem.processedAt : '',
      showNoFlowNotification: false,
      establishSignNoLogin: (enterpriseSignItem.isSignNoLogin != null) ? enterpriseSignItem.isSignNoLogin : false,
      isSignedAnonymous: (enterpriseSignItem.isSignedAnonymous != null) ? enterpriseSignItem.isSignedAnonymous : false,
      type: this.enumContractDetailType.DETAIL,
      signMethod: enterpriseSignItem.signMethod,
      signMetadata: signMetadata,
      identityStatus: enterpriseSignItem.identityStatus ? enterpriseSignItem.identityStatus : null,
      enterpriseId: enterpriseSignItem.enterpriseId,
      identityReason: enterpriseSignItem.identityReason ? enterpriseSignItem.identityReason : null,
      isCreatedSide: enterpriseSignItem.isCreatedSide,
      enterpriseType:enterpriseSignItem.enterpriseType,
      signConfigEnterprise: enterpriseSignItem.signConfig ? (JSON.parse(enterpriseSignItem.signConfig).showImage ? JSON.parse(enterpriseSignItem.signConfig) : {showImage: false}) : {showImage: false}
    });
    return childrenItems
  }

  funcionTime(str){
    return /[a-zA-Z]/.test(str);
  }

  setDataSignConfig(signConfig: any) {
    let newDataSignConfig = { ...signConfig };
    if(newDataSignConfig.resize === null || newDataSignConfig.resize === undefined) {
      newDataSignConfig = { ...newDataSignConfig, resize: false };
    }
    if(newDataSignConfig.showImage === null || newDataSignConfig.showImage === undefined) {
      newDataSignConfig = { ...newDataSignConfig, showImage: true };
    }
    return newDataSignConfig;
  }
  private checkmatched(listFileName: string[], name: string) {
    const filenameSplit = name.split('.')
    const type = filenameSplit.pop();
    const fileName = filenameSplit.join('.');
    let fileNameConverted = fileName + '.' + type;
    let k = 1;
    if (listFileName.length > 0) {
      while (listFileName.includes(fileNameConverted)) {
        fileNameConverted = fileName + '(' + k + ').' + type;
        k++;
      }
    }


    return fileNameConverted;
  }
  viewContract(ala,data?) {
      if(ala.typeId == 2){
        this.blockUI.start();
        this.digitalContractService.getContractByIdAnonymous(ala.id, this.tenantId, this.hashKey).pipe(finalize(()=> this.blockUI.stop())).subscribe(async res => {
          if (res.data && res.success) {
            this.contractView.contractName = res.data.code + ' - ' + res.data.name;
            const attachments = res.data.contractAttachments
            if (attachments.length > 0) {
              this.blockUI.start();
              const nameList = [];
              const idList = [];
              const listFileSize = [];

              for (let file of attachments) {
                nameList.push(this.checkmatched(nameList, file.fileName));
                idList.push(file.id)
                listFileSize.push(file.fileSize)
                if (idList.length === attachments.length) {
                  this.blockUI.stop();
                }
              }
              this.contractView.filesName = nameList;
              this.contractView.id = idList;
              this.contractView.listFileSize = listFileSize;
              this.anonymousSignService.setIsShowReferencePdf(true)
              this.contractView.idDocument = ala.id;
              if(data){
                this.contractView.checkMan = data;
              }
              this.contractView.isAnonymous = true
              this.contractView.attachments = attachments
              if(this.document.formType == "CONTRACT_TERMINATION" && this.document.status == 4){
                this.contractView.isTerminate = true
              }
              const dialog = this.dialog.open(ViewContractComponent, {
                data: this.contractView,
                width: '90%',
                minHeight: '90%'
              });
              dialog.afterClosed().subscribe(res => {
                this.anonymousSignService.setIsShowReferencePdf(false)
              })
              // this.blockUI.stop();

            }
          } else {
            this.toastr.error(res.message);
          }
        });

      }
      else {
        this.viewDocumentReference(ala);
      }

    }

    messages: MessageNegotiate[] = [
    ];
    newMessage = '';
    fileList: File[] = [];
    replyId: string = '';
    replyMessageData: any = null;
    isNegotiate: boolean = false
    onFileSelected(event: Event): void {
      const input = event.target as HTMLInputElement;
      if (input.files) {
        let isValidFile = true
        Array.from(input.files).forEach(file => {
          if(!this.validateFile(file)){
            isValidFile = false
            return
          }
        })

        if(this.fileList.length + Array.from(input.files).length > this.maxNumberFile ){
          this.toastr.error(this.message.getMessage('negotiate_contract.chat.error_number_file').replace('{0}', this.maxNumberFile.toString()))
          input.value = '';
          return
        }
        if(isValidFile) {
          let totalSize = 0;
          this.fileList.forEach(file => totalSize = totalSize + file.size)
          Array.from(input.files).forEach(file => totalSize = totalSize + file.size)
          if(totalSize < this.maxSize) {
            this.fileList = [...this.fileList, ...Array.from(input.files)];
          } else {
            this.toastr.error(this.message.getMessage('negotiate_contract.chat.error_total_size').replace('{0}', this.formatFileSize(this.maxSize)))
          }
          input.value = '';
        } else {
          input.value = '';
        }
         // Reset input file
      }
    }

    removeFile(index: number): void {
      this.fileList.splice(index, 1);
    }

    sendMessage(): void {
      if (!this.canReplyNegotiation) { this.clearReplyMessageData(); }
      if (this.newMessage.trim() || this.fileList.length > 0) {
        const dataMessage = new FormData()
        dataMessage.append('contractId', this.document.id)
        dataMessage.append('content', this.newMessage.trim())
        dataMessage.append('tenantId', this.tenantId)
        dataMessage.append('hashKey', this.hashKey)
        dataMessage.append('parentId', this.replyId)
        if (this.fileList.length > 0) {
          this.fileList.forEach(file =>{
            dataMessage.append('mFiles', file)
          })
        }
        this.newMessage = '';
        this.fileList = [];
        this.clearReplyMessageData()
        this.documentService.commitNegotiateAnonymous(dataMessage).pipe(finalize(()=>{
          this.newMessage = '';
          this.fileList = [];
        })).subscribe(res => {
          console.log(res);
          this.getHistoryChat(true)
          if(!res.success){
            this.toastr.error(res.message)
          }
        })
      }
    }

    truncateFileName(name: string, maxLength = 25): string {
      if (name.length <= maxLength) return name;
      const ext = name.substring(name.lastIndexOf('.'));
      const truncated = name.substring(0, maxLength - ext.length - 3);
      return `${truncated}...${ext}`;
    }

    formatFileSize(bytes: number, decimals = 2): string {
      if (bytes == 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      const size = parseFloat((bytes / Math.pow(k, i)).toFixed(decimals));
      return `${size} ${sizes[i]}`;
    }

    intervalChat: any;
    getHistoryChat(isScroll: boolean = false){
      this.documentService.getHistoryNegotiateAnonymous({
        contractId: this.document.id,
        hashKey: this.hashKey,
        tenantId: this.tenantId,
      }).pipe(finalize(()=> {
        if(isScroll) {
          this.zone.onStable.pipe(take(1)).subscribe(() => {
            this.scrollToBottom();
          });
        }
      })).subscribe(res =>{
        if (res.success) {
          console.log(res.data);
          const emptyValueLabel = this.message.getMessage1('negotiate_contract.chat.empty_value');
          this.messages = (res.data || []).map(item => mapNegotiateMessage(item, emptyValueLabel));
          this.cdr.detectChanges()
        } else {
          this.toastr.error(res.message)
        }
      })
    }

    private expandedMergeHistories = new Set<string>();

    isMergeHistoryExpanded(entry: MessageNegotiate): boolean {
      return this.expandedMergeHistories.has(this.document.id + ':' + entry.id);
    }

    toggleMergeHistory(entry: MessageNegotiate): void {
      const key = this.document.id + ':' + entry.id;
      if (this.expandedMergeHistories.has(key)) {
        this.expandedMergeHistories.delete(key);
      } else {
        this.expandedMergeHistories.add(key);
      }
    }

    allowedExtensions = [
      '.pdf', '.jpg', '.jpeg', '.png', '.bmp', '.msg', '.eml',
      '.rtf', '.doc', '.docx', '.xls', '.xlsx'
    ];

    allowedMimeTypes = [
      'application/pdf',
      'image/jpeg', 'image/png', 'image/bmp',
      'application/vnd.ms-outlook', // .msg
      'message/rfc822',             // .eml
      'application/rtf',
      'application/msword',         // .doc
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
      'application/vnd.ms-excel',   // .xls
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' // .xlsx
    ];
    maxSize: number = 10*1024*1024
    validateFile(file: File): boolean {
      const fileExt = '.' + file.name.split('.').pop().toLowerCase();
      const isValidExt = this.allowedExtensions.includes(fileExt);
      const isValidType = this.allowedMimeTypes.includes(file.type);

      if ((!isValidExt || !isValidType ) && !(fileExt == '.msg' && file.type == "")) {
        this.toastr.error(this.message.getMessage('negotiate_contract.chat.error_format_file') + `: ${file.name}`)
        return false;
      }
      if (file.size == 0) {
        this.toastr.error(this.message.getMessage('negotiate_contract.chat.error_no_size'))
        return false;
      }
      return true;
    }

    downLoadFileNegotiate(file: any) {
      this.documentService.downLoadFileNegotiateAnonymous(file.filePath,this.tenantId).subscribe(rs => {
        if(rs.type == 'application/json') {
          this.toastr.error(this.message.getMessage('messages.no_permission_on_document'))
          return;
        }
        let type: string = '';
        if (file.fileName.slice(-3).toLowerCase() === 'pdf') {
          type = 'pdf';
          const reader = new FileReader();
          reader.readAsDataURL(rs);
          reader.onload = (event) => {
            const path = event.target == null ? '' : (event.target as any).result;
            const filePath = path as string;
            const filePathBase64 = filePath.split(',')[1];
            this.previewPdf({filePath: file.filePath, filePathBase64: filePathBase64, fileName: file.fileName, type: type, fileId: file.id});
          }
        } else if(['png','jpg', 'bmp'].includes(file.fileName.slice(-3).toLowerCase()) || file.fileName.slice(-4).toLowerCase() == 'jpeg'){
          type = 'image'
          // const image = new Blob([rs], { type: 'image/png' });
          const imageURL = URL.createObjectURL(rs);
          this.previewPdf({type: type, fileName: file.fileName, fileId: file.id, imageURL: imageURL, filePath: file.filePath});
        } else {
          this.downLoadFile(rs, 'application/octet-stream', file.fileName)

        }

      });
    }
  maxNumberFile: number = 10;
  @ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef;
  @ViewChild('textAreaRef', { static: false }) textAreaRef!: ElementRef;
  @ViewChildren('messageItem') messageItems!: QueryList<ElementRef>;
  isComment: boolean = true
  scrollToBottom(): void {
      if (this.scrollContainer && this.scrollContainer.nativeElement) {
        this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight;
      }
  }
  onKeyDown(event: KeyboardEvent){
    if (isChatSubmitKey(event)) {
      event.preventDefault();
      this.sendMessage();
    }
  }
  public getNegotiateCopyText = getNegotiateCopyText;

  get canReplyNegotiation(): boolean {
    return !!(this.document && this.document.status === EnumContractStatus.DRAFT);
  }

  replyMessage(messageInfo: any){
    if (!this.canReplyNegotiation) { return; }
    this.replyId = messageInfo.id
    this.replyMessageData = messageInfo
  }

  clearReplyMessageData(){
    this.replyId = ""
    this.replyMessageData = null
  }
  previewPdf(dataFile: any) {
    const data = {
      ...dataFile
    };
    this.anonymousSignService.setIsShowReferencePdf(true)
    const dialogRef = this.dialog.open(ViewFilePdfImgComponent, {
      width: '1000px',
      data,
      minWidth: '365px'
    });
    dialogRef.afterClosed().subscribe(rs => {
      this.anonymousSignService.setIsShowReferencePdf(false)
    });
  }
  scrollToMessage(data){
    if (data.id) {
      const element = document.getElementById(`message-id-${data.id}`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        element.classList.add('focused');
        setTimeout(() => {
          element.classList.remove('focused');
        }, 1000);
      }
    } else {
      // alert('Không tìm thấy tin nhắn!');
    }
  }
  getTailFile(name: string){
    return name.split('.').pop()
  }
  copyMessage(text){
    navigator.clipboard.writeText(text)
  }
  isHover: any = null
  isActive: any = null

  hiddenCerrtificateNo(certificateNo: string){
    if(certificateNo){
      return certificateNo.includes('-null')
    } else {
      return false
    }
  }
}
